import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { MaterialDto } from './material.dto';
import { MaterialCascadableInterface } from '../interfaces/material-cascadable.interface';

export class MaterialCascadeDto
  extends IntersectionType(
    PickType(MaterialDto, ['name', 'unit', 'amount']),
    PartialType(PickType(MaterialDto, ['description'])),
  )
  implements MaterialCascadableInterface {}
